import { Trans, useTranslation } from 'react-i18next';

import { setShowOatFiOnboardingModal } from 'components/submitDashboard/submitDashboardSlice';
import Button, { ButtonSize, ButtonVariant } from 'components/Button';
import { ArrowLeftIcon } from 'components/icons/ArrowLeftIcon';
import { useAppSelector, useAppDispatch } from 'hooks';
import { getBusiness } from 'pages/Profile/selectors';
import Alert, { AlertTypes } from 'components/Alert';
import Link from 'components/Link';

import { getIsCapitalProductActive } from './Progress/selectors';

const OatFiAlert = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('dashboard');

  const isCapitalProductActive = useAppSelector(getIsCapitalProductActive);
  const business = useAppSelector(getBusiness);

  if (
    !isCapitalProductActive ||
    business.submittedByPersonsId === null ||
    business.submittedByPersonsId === 0 ||
    business.oatFiBusinessExternalId
  ) {
    return null;
  }

  return (
    <Alert
      type={AlertTypes.info}
      className="mb-6"
      withBorder
      title={t('alerts.oatFi.title')}
      withClose
      description={
        <div className="flex items-center justify-between pr-7">
          <p className="mr-2">
            <Trans
              i18nKey="dashboard:submitModal.lineOfCredit.text"
              components={{
                1: (
                  <Link
                    href="https://oatfi.com"
                    target="_blank"
                    className="underline"
                    styles={{
                      color: 'inherit',
                      ':hover': { color: 'inherit' },
                    }}
                  />
                ),
              }}
            />
          </p>

          <Button
            variant={ButtonVariant.secondaryOutline}
            size={ButtonSize.medium}
            heightClass="h-8"
            onClick={() => dispatch(setShowOatFiOnboardingModal(true))}
            className="flex-shrink-0"
          >
            <span className="text-sm font-semibold">
              {t('alerts.oatFi.button')}
            </span>
            <ArrowLeftIcon className="text-gray-500 w-4 h-4 ml-2 rotate-180" />
          </Button>
        </div>
      }
    />
  );
};

export default OatFiAlert;
